<template>
  <div class="login-button">
    <input
      type="button"
      :value="value"
      :disabled="disabled"
      @click="buttonClick"
    />
  </div>
</template>

<script>
export default {
  props: {
    disabled: null,
    value: null,
  },
  data() {
    return {};
  },
  methods: {
    buttonClick() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.login-button {
  margin: 40px 16px 0;
  height: auto;
  input {
    width: 100%;
    height: 50px;
    border-radius: 50px;
    background-color: $theme-color-main;
    border: none;
    color: #fff;
    font-size: 18px;
    outline: none;
  }
  input:disabled {
    background-color: $theme-color-disabled;
  }
}
</style>

